import type {
    UpdateDocumentDetailsRequest,
    UpdateDocumentNumbersRequest
} from '@dtos/update-documents';
import { IConfigurationValuesService } from '@services/ConfigurationValuesService';
import { RequireAuthenticationToken } from '@services/http/authorisation-interceptor';
import { IHttpService } from '@services/HttpService';

export interface IDocumentUpdateApiService {
    updateDocumentDetailsAsync(request: UpdateDocumentDetailsRequest): Promise<boolean>;
    updateDocumentNumbersAsync(request: UpdateDocumentNumbersRequest): Promise<boolean>;
}

export enum DocumentUpdateEndpoint {
    updateDetails = '/document/details',
    updateNumbers = '/document/numbers'
}

export class DocumentUpdateApiService implements IDocumentUpdateApiService {
    static readonly basePath = '/worker-onboarding/external/representative';

    constructor(
        private configurationValuesService: IConfigurationValuesService,
        private httpService: IHttpService
    ) {
    }

    get apiPrefix(): string {
        return `${this.configurationValuesService.apiUrl}${DocumentUpdateApiService.basePath}`;
    }

    @RequireAuthenticationToken
    async updateDocumentDetailsAsync(request: UpdateDocumentDetailsRequest): Promise<boolean> {
        const url = `${this.apiPrefix}${DocumentUpdateEndpoint.updateDetails}`;
        const response = await this.httpService.post(url, request);
        return response.status === 200;
    }

    @RequireAuthenticationToken
    async updateDocumentNumbersAsync(request: UpdateDocumentNumbersRequest): Promise<boolean> {
        const url = `${this.apiPrefix}${DocumentUpdateEndpoint.updateNumbers}`;
        const response = await this.httpService.post(url, request);
        return response.status === 200;
    }
}



// WEBPACK FOOTER //
// ./src/services/document-update-api-service.ts